import { Typography } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'

import Modal from 'components/molecules/Modal/Modal'
import { LoadingButton } from 'components/mui'
import useDTMS3Image from 'lib/utils/useDTMS3Image'

import './ReferenceImageAccurateModal.scss'

interface ReferenceImageAccurateModalProps {
  open: boolean
  onClose: () => void
  handleConfirm: () => void
  handleCaptureNew: () => void
  imageUrl?: string
}

const ReferenceImageAccurateModal = ({
  open,
  onClose,
  handleConfirm,
  handleCaptureNew,
  imageUrl,
}: ReferenceImageAccurateModalProps) => {
  const { imageUrl: signedImageUrl, isLoading } = useDTMS3Image({
    url: imageUrl,
    defaultImage: '',
  })

  return (
    <Modal open={open} onClose={onClose}>
      <div className="reference-image-accurate-modal">
        <div className="header-box">
          <HelpOutline />
          <Typography variant="h3">
            Is the current reference image accurate?
          </Typography>
        </div>
        <Typography variant="body1" className="modal-description">
          Before saving your changes, please confirm if the current reference
          image accurately represents the tray contents.
        </Typography>

        {signedImageUrl && (
          <div className="image-preview-container">
            {isLoading ? (
              <div className="image-loading-skeleton" />
            ) : (
              <img
                src={signedImageUrl}
                alt="Current reference"
                className="reference-image-preview"
              />
            )}
          </div>
        )}

        <div className="buttons-container">
          <LoadingButton
            disabled={false}
            loading={false}
            variant="outlined"
            onClick={handleCaptureNew}
          >
            Capture New Image
          </LoadingButton>

          <LoadingButton
            disabled={false}
            loading={false}
            onClick={handleConfirm}
          >
            Yes, It's Accurate
          </LoadingButton>
        </div>
      </div>
    </Modal>
  )
}

export default ReferenceImageAccurateModal
